// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"styles_textAreaContainer__Yw038","inputTextAreaError":"styles_inputTextAreaError__CII3-"};